module.exports = __webpack_public_path__ + "img/whiteAPp.26cb98dd.svg";